import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from '../../../shared/common.service';
import { AuthService } from '../../auth.service';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { bool } from 'aws-sdk/clients/signer';
import { MatSnackBar } from '@angular/material';
import Swal from 'sweetalert2';
import { ImageCroppedEvent } from 'ngx-image-cropper';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  @Output() imageUploaded = new EventEmitter();
  @Output() imageError = new EventEmitter();
  @Output() imageLoadedToContainer = new EventEmitter();
  @Output() croppingCanceled = new EventEmitter();
  // loginForm: FormGroup;
  signForm: FormGroup;
  isUploading:boolean = true;
  isLogin:boolean = true;
  profilePic:string = "";
  minDate = new Date();
  formSubmitted: boolean = false;
  errorMsg: string = "Ok";
  headers = [];
  Loginmessage: string = "";
  isLoading: boolean = false;
  isValid:boolean;
  other:any ="";
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
 
  constructor(private fb: FormBuilder,
    private authServices: AuthService,
    private commonService: CommonService,
    private router: Router,
    private _snackBar: MatSnackBar,) { }

  ngOnInit() {
    this.initialiseForms();
  }
  // initialiseForms() {
  //   this.loginForm = this.fb.group({
  //     name: ["", [Validators.required]],
  //     type: ["", [Validators.required]],
  //     date: ["", [Validators.required]],
  //     location: ["", [Validators.required]],
  //     bio: ["", [Validators.required]],
  //     refcode: ["", [Validators.required]],
  //   });
  // }

 

  loginFN() {
    this.router.navigate(['main/dashboard'])
  }
  SwitchLogin(value){
    if (value == 'true') {
      this.isLogin = true;
    }else {
      this.isLogin = false;
    }

  }

  imageChangedEvent: any = '';
  imageChangedEvent1: any = '';
  croppedImage: any = '';
  fileChangeEvent(event: any): void {
    this.isLoading = true;
    let file, img;
    if ((file = event.target.files[0]) && (file.type === "image/png" || file.type === "image/jpeg")) {
        img = new Image();
        this.imageChangedEvent = event;
    }
     else {
          Swal.fire({
              icon: 'error',
              html: 'Unsupported File Type. Only jpeg and png is allowed!'
          });
      }
      this.isLoading = false;
  }


  b64toBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
}


  save() {

    const  blob = this.b64toBlob(this.croppedImage);
    this.imageChangedEvent = null;
    this.isLoading = true;
    this.authServices.uploadImage(blob).subscribe(res => {
      this.isLoading =false;

        if ( res['message'] === 'Success') {
            this.profilePic = res['data'].imageUrl;
            this.signForm.controls['profilePic'].setValue(this.profilePic);
          //  console.log('Image url',this.profilePic)
  
        }
    });
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
   // console.log(this.croppedImage,'CropImage')
  }
  
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }

//   login() {
//     this.formSubmitted = true;
//     if (this.loginForm.valid) {
//       let req = {
//         email: this.loginForm.controls["userName"].value.trim(),
//         password: this.loginForm.controls["password"].value.trim()
//       };
//       this.isLoading = true;
//       this.authServices.validateLogin(req).subscribe((res: HttpResponse<any>) => {
//         this.isLoading = false;
//         if ((res["message"] = "Success")) {
//           this.commonService.setStorage("token", res.headers.get('Authorization'));
// console.log("LOFIN")
//           this.router.navigate(["main/video"]);
//         } else {
//         }
//       },
//         err => {
//           this.isLoading = false;
//         });
//     }
//   }

initialiseForms() {
  this.signForm = this.fb.group({
        companyName: ["", [Validators.required]],
        email: ["", [Validators.required,Validators.pattern(this.emailPattern)]],
        password: ["", [Validators.required,Validators.minLength(6)]],
        companyType: ["", [Validators.required]],
        dateEstablished: ["", [Validators.required]],
        location: ["", [Validators.required]],
        bio: ["", [Validators.required]],
        inviteCode: ["", [Validators.required]],
        role: ["C", [Validators.required]],
        userType: ["web", [Validators.required]],
        profilePic: [""],

      });
} 

validateCode() {
  let code = this.signForm.value.inviteCode;
  if(code == "") {
    return null
  }
  this.authServices.validateInviteCode(code).subscribe(
    res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
        if(res.data.found.status =='used') {
          this.isValid = false;
          this._snackBar.open("Invite code already used !","",{
            duration: 5000,
            horizontalPosition:'right',
            verticalPosition:'top',
            panelClass: ['error']
          });
        }else {
          this.isValid = true;
        }
      } else {
      }
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
      this.isValid =true;
    }
  );
}
formSubmit:boolean = false;
submit () {
  this.formSubmit = true;
  let req = this.signForm.value;
  console.log(req)
  if(this.other !== '') {
    req['companyType'] = this.other;
  }
  if(req['profilePic'] == '') {
      delete req['profilePic']
  }
  let epocDate = new Date(this.signForm.value.dateEstablished);
  let FinalepocDate =Math.floor(epocDate.getTime() / 1000);
  req['dateEstablished'] = FinalepocDate
;  console.log(req,'final')
if(this.signForm.valid) {
  this.isLoading = true;
  this.authServices.createCompany(req).subscribe(
    res => {
      this.isLoading = false;
      if ((res["message"] = "Success")) {
        if(res.headers.get('Authorization')){
          this.commonService.setStorage("token", res.headers.get('Authorization'));
        }
        this.commonService.setStorage("token", res.body.data.accessToken);
          this.router.navigate(['main/dashboard'])
        this.router.navigate(['main/dashboard'])
        this._snackBar.open("Company created successfully!!","",{
          duration: 3000,
          horizontalPosition:'right',
          verticalPosition:'top',
          panelClass: ['failure']
        });

      } else {
      }
      this.isLoading = false;
    },
    err => {
      this.isLoading = false;
    }
  );
}
}
cancel(): void {
  this.croppedImage = null;
  this.imageChangedEvent = null;
  this.isUploading = false;
  setTimeout(() => {
      /** spinner ends after 1 seconds */
      this.isUploading= true;
    }, 1000);
}
}
